import type { TourStep } from "../tour-steps";
import { CONFIGURACOES, EQUIPE, ajudaFinal, area, boasVindas } from "./passos";

/** Laboratório: quem manda trabalho (cadastros) → o que se vende (catálogo) → pedido → produção →
 *  estoque e dinheiro. */
export const tourDoLaboratorio = (c: boolean): TourStep[] => [
  boasVindas(
    "Bem-vindo ao seu laboratório no DentalBook",
    "Em um minuto você vê o caminho de um trabalho: as clínicas que mandam, o catálogo, o pedido chegando, a produção e o financeiro.",
  ),
  area(c, {
    id: "inicio",
    menu: "sidebar-inicio",
    aba: "aba-inicio",
    nome: "Início",
    titulo: "Resumo do laboratório",
    texto: "O Início mostra os pedidos por prazo e o que precisa da sua atenção hoje.",
  }),
  area(c, {
    id: "cadastros",
    menu: "sidebar-cadastros",
    nome: "Cadastros",
    titulo: "Clínicas e dentistas parceiros",
    texto: "Cadastre as clínicas e os dentistas que mandam trabalho ou convide-os por link. Conectados, eles pedem direto pela plataforma.",
  }),
  area(c, {
    id: "catalogo",
    menu: "sidebar-catalogo",
    nome: "Catálogo",
    titulo: "O que o laboratório oferece",
    texto: "Serviços, materiais, cores e preços — tabela base, tabelas de convênio e exceções por clínica. É o que o dentista escolhe ao montar o pedido.",
  }),
  area(c, {
    id: "pedidos",
    menu: "sidebar-pedidos",
    aba: "aba-pedidos",
    nome: "Pedidos",
    titulo: "Pedidos que chegam",
    texto: "Os pedidos das clínicas chegam aqui. Aceitar manda para a produção; recusar devolve à clínica com o motivo.",
  }),
  area(c, {
    id: "producao",
    menu: "sidebar-producao",
    aba: "aba-producao",
    nome: "Produção",
    titulo: "Produção",
    texto: "Cada serviço aceito aparece por estágio, em quadro ou planilha, com responsável e prazo. Ao terminar, finalize o serviço.",
  }),
  area(c, {
    id: "estoque",
    menu: "sidebar-estoque",
    nome: "Estoque",
    titulo: "Estoque de insumos",
    texto: "Saldos, sugestão de compra e entradas de fornecedor. O consumo de cada serviço baixa o estoque sozinho.",
  }),
  area(c, {
    id: "financeiro",
    menu: "sidebar-financeiro",
    nome: "Financeiro",
    titulo: "Financeiro",
    texto: "A receber das clínicas, contas a pagar, lançamentos e o resultado do mês. Os trabalhos concluídos já entram como cobrança.",
  }),
  area(c, {
    id: "arquivos",
    menu: "sidebar-arquivos-lab",
    nome: "Arquivos",
    titulo: "Arquivos dos trabalhos",
    texto: "Escaneamentos, fotos e modelos 3D ligados ao pedido ou à clínica — inclusive os que as clínicas enviaram.",
  }),
  EQUIPE(c, "aba-equipe"),
  CONFIGURACOES(c),
  ajudaFinal(),
];
